import { Component, EventEmitter, Output } from "@angular/core";

export interface Will4HealthcareHowItWorksStep {
	number: number;
	iconSrc: string;
	iconAlt: string;
	title: string;
	description: string;
}

@Component({
	selector: "app-will4-healthcare-how-it-works-section",
	templateUrl: "./will4-healthcare-how-it-works-section.component.html",
	styleUrls: ["./will4-healthcare-how-it-works-section.component.scss"],
})
export class Will4HealthcareHowItWorksSectionComponent {
	@Output() ctaClick = new EventEmitter<void>();

	readonly steps: Will4HealthcareHowItWorksStep[] = [
		{
			number: 1,
			iconSrc: "../../../assets/images/healthcare-how-step-1.svg",
			iconAlt: "Create Your Free Healthcare Directive",
			title: "Create Your Free Healthcare Directive",
			description:
				"Answer simple step-by-step questions online to document your healthcare wishes and preferences.",
		},
		{
			number: 2,
			iconSrc: "../../../assets/images/healthcare-how-step-2.svg",
			iconAlt: "Appoint Someone You Trust",
			title: "Appoint Someone You Trust",
			description:
				"Choose a parent, spouse, family member, or another trusted individual to help make healthcare decisions if you become unable to communicate your wishes.",
		},
		{
			number: 3,
			iconSrc: "../../../assets/images/healthcare-how-step-3.svg",
			iconAlt: "Download, Sign, and Share",
			title: "Download, Sign, and Share",
			description:
				"Download and complete your directive, then share copies with family members, healthcare providers, or trusted loved ones.",
		},
	];

	onCtaClick(): void {
		this.ctaClick.emit();
	}
}
